import { BASE_ASSETS } from "@assets/templates/constants";
import type { ComposeTemplate } from "@assets/templates/types";

export const preShipmentInspectionExample: ComposeTemplate = {
  mode: "compose",
  slug: "pre-shipment-inspection-example",
  version: 1,
  title: "Pre-shipment inspection",
  description: "Verify every item before dispatch",
  subdescription: "Spot missing, incorrect, and extra items across two images",
  thumbnailUuid: BASE_ASSETS.approvedEquipmentKit.uuid,
  assets: [BASE_ASSETS.approvedEquipmentKit, BASE_ASSETS.packedEquipmentKit],
  featured: true,
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "paragraph",
        value: { type: "text", value: "Approved equipment kit:" },
      },
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.approvedEquipmentKit.uuid,
              extension: BASE_ASSETS.approvedEquipmentKit.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Packed kit:" },
      },
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.packedEquipmentKit.uuid,
              extension: BASE_ASSETS.packedEquipmentKit.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value:
            "Compare the approved equipment kit with the packed kit. In the first select items that are missing from the second photo, these items are considered 'missing'. In the second photo draw boxes around items that are not in the first photo, these items are considered 'extra'. Reference each item by its name as well. Use asset_idx.",
        },
      },
    ],
    temperature: 0,
    outputAnnotations: false,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
    tools: [],
  },
};
